import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

fetch('assets/config.json')
  .then((response) => {
    if (!response.ok) {
      throw new Error(`Failed to load assets/config.json (status: ${response.status})`);
    }
    return response.json();
  })
  .then((config) => {
    if (config) {
      Object.assign(environment, config);
    }
    return platformBrowserDynamic().bootstrapModule(AppModule);
  })
  .catch((err) => {
    console.warn('Could not load assets/config.json, using default environment:', err);
    return platformBrowserDynamic().bootstrapModule(AppModule);
  })
  .catch((err) => console.error(err));
